//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue' // 头部
export default {
  components: {
    'user-header': userHeader
  },
  props: {
    phone: {
      type: [Number, String],
      default: '未传入手机号'
    },
    titStr: {
      type: Boolean,
      default: true
    },
    formatError: {
      type: String,
      default: ''
    },
    areaCode: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title: this.$v('图形验证码'),
      smsState: false, // 验证码样式
      smsCodeTxt: '', // 验证码绑定
      clearButton: false,
      graphicalImg: '' // 图形验证码图片
    }
  },
  watch: {
    smsCodeTxt (val) {
      if (val) {
        this.clearButton = true // 清空按钮and下一步按钮
      } else {
        this.clearButton = false // 清空按钮and下一步按钮
      }
    }
  },
  mounted () {
    this.Graphical()
  },
  methods: {
    async Graphical () { // 图形验证码
      const { succeed = false, extra = '', result = {} } = await this.$api.login.usergraphical({ areaCode: this.areaCode, userId: this.userId, phonenumber: this.phone, length: 4, width: 140, heigth: 40 })
      if (!succeed) return console.log(extra) // 数据错误
      this.graphicalImg = result
    }
  }
}
